export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    scrollToServicesSection();
  },
};

/**
 * Scrolls to Services section when homepage hero section button is clicked
 */
function scrollToServicesSection() {
  $('.hero-section__button').click(() => {
    const services = $('#services');
    const adminBar = $(document.body).hasClass('logged-in') ? 32 : 0;
    const header = 106;
    let servicesOffset = services.offset().top - adminBar - header;

    $([document.documentElement, document.body]).animate(
      {
        scrollTop: servicesOffset,
      },
      1000
    );
  });
}



// WEBPACK FOOTER //
// ./scripts/routes/home.js